import { Types } from "../actions/CustomListActions";

const initialState = {
    isTaskUpdated: false,
};

export const customListReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.IS_UPDATED_TASK_CUSTOM_LIST:
            return {
                ...state,
                isTaskUpdated: true,
            };
        case Types.RESET_IS_UPDATED_TASK_CUSTOM_LIST:
            return {
                ...state,
                isTaskUpdated: false,
            };
        default:
            return state;
    }
};
